import { Button, Form, Typography } from "antd";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import checkImg from "../../assets/v2/check.png";
import style from "./ChangePassword.module.css";
import { useEffect, useState } from "react";

const { Title, Text, Paragraph } = Typography;

export default function Success() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/login");
  };

  return (
    <>
      <div style={{ marginBottom: "1.25rem" }}>
        <img alt="Bevz" src={checkImg} width="111px" height="111px" />
      </div>
      <Title style={{ fontSize: "30px", margin: 0, marginBottom: "1.875rem" }}>
        Password changed!
      </Title>
      <Paragraph
        style={{
          color: "#515151",
          fontSize: "16px",
          textAlign: "center",
          marginBottom: "1.875rem",
        }}
      >
        Your password has been changed successfully.
      </Paragraph>

      <Button
        size="large"
        className={style.BlueBrandButton}
        onClick={handleGoBack}
      >
        Back to Login
      </Button>
    </>
  );
}
